const getters = { 
  permission_routes: state => state.permission.routes,
  user: state => state.user,
  appconfig: state => state.appconfig,
}
export default getters
